import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

// Components
import { Link, Text } from '@beef/ui-kit';
import { I18n, Icon } from 'components';
import { DeleteButton } from '../DeleteButton';

// Styles
import styles from './styles.pcss';

const cn = classNames.bind(styles);

const NoLimitsAvailable = ({ noLimitsAvailableText, handleDeleteBtnClick, showMoreTariffsUrl }) => (
  <>
    {noLimitsAvailableText && (
      <div className={cn('block__description')}>
        <Text size="size5-r-s" color="grey50">{noLimitsAvailableText}</Text>
      </div>
    )}
    {showMoreTariffsUrl && (
      <div className={cn('block__button')}>
        <Link
          href={showMoreTariffsUrl}
        >
          <Text size="size5-m">
            <I18n path="family.ctnSetupTexts.showAllTariffsBtnText" />
          </Text>
          <Icon name="arrow" className={cn('block__icon')} />
        </Link>
      </div>
    )}
    {handleDeleteBtnClick && (
      <DeleteButton handleDeleteBtnClick={handleDeleteBtnClick} />
    )}
  </>
);

NoLimitsAvailable.propTypes = {
  noLimitsAvailableText: PropTypes.string,
  handleDeleteBtnClick: PropTypes.func,
  showMoreTariffsUrl: PropTypes.string,
};

export { NoLimitsAvailable };
